import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=bd3be9d0&scoped=true&"
import script from "./RolesPage.vue?vue&type=script&lang=js&"
export * from "./RolesPage.vue?vue&type=script&lang=js&"
import style0 from "./RolesPage.vue?vue&type=style&index=0&id=bd3be9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3be9d0",
  null
  
)

export default component.exports